import { ref } from 'vue';

const focusPanes = ref<Record<string, boolean>>({});

export const useSdfFocusPane = () => {
  const show = (name: string) => {
    focusPanes.value[name] = true;
  };

  const hide = (name: string) => {
    delete focusPanes.value[name];
  };

  const hideAll = () => {
    Object.keys(focusPanes.value).forEach((name) => hide(name));
  };

  return { focusPanes, show, hide, hideAll };
};
